<template>
  <v-container
    fluid
  >
    <v-form>
      <v-container>
        <v-btn
          class="ma-2 float-left"
          tile
          outlined
          :loading="btnLoading"
          :disabled="btnLoading"
          color="success"
          @click="save()"
        >
          <v-icon
            left
          >
            mdi-check
          </v-icon>
          {{ $t('save') }}
        </v-btn>
        <v-subheader
          class="display-1"
        >
          {{ $t('operations_settings') }}
        </v-subheader>
        <v-card-text>
          <v-row>
            <v-col
              md="12"
            >
              <v-subheader>{{ $t('table_row_count') }}</v-subheader>
              <v-slider
                v-model="ProductsCPP"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template
                  v-slot:append
                >
                  <v-text-field
                    v-model="ProductsCPP"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  />
                </template>
              </v-slider>
            </v-col>
            <v-col
              md="12"
            >
              <v-select
                v-model="productsValue"
                :items="productsItems"
                item-text="display"
                item-value="dbitem"
                :label="$t('columns')"
                chips
                dense
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-subheader
          class="display-1"
        >
          {{ $t('category_settings') }}
        </v-subheader>
        <v-card-text>
          <v-row>
            <v-col
              md="12"
            >
              <v-subheader>{{ $t('table_row_count') }}</v-subheader>
              <v-slider
                v-model="ProductsCategoriesCPP"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template v-slot:append>
                  <v-text-field
                    v-model="ProductsCategoriesCPP"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  />
                </template>
              </v-slider>
            </v-col>
            <v-col
              md="12"
            >
              <v-select
                v-model="productsCategoriesValue"
                :items="productsCategoriesItems"
                item-text="display"
                item-value="dbitem"
                :label="$t('columns')"
                chips
                dense
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-container>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    name: 'Settings',
    data: () => ({
      btnLoading: false,
      valid: false,
      ProductsCPP: 0,
      ProductsCategoriesCPP: 0,
      min: 1,
      max: 100,
      productsItems: [],
      productsValue: [],
      productsCategoriesItems: [],
      productsCategoriesValue: [],
      dynamicColumns: [],
      snackbar: false,
      snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
      snackbarText: '',
    }),
    async created () {
      await this.getOptions()
      await this.getDynamicColumns()
      await this.getProductsCategoriesColumns()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showLikeTitle', {
          title: 'Products',
        }).then(
          response => {
            const result = response.data.Option
            this.ProductsCPP = parseInt(result.find(x => x.title === 'Products-CPP').value)
            this.ProductsCategoriesCPP = parseInt(result.find(x => x.title === 'Products-Categories-CPP').value)
            let tempValue = result.filter(x => x.title === 'Products-TH-Operations')
            let tempArray = []
            tempValue.forEach(function (value) {
              tempArray.push(value.value)
            })
            this.productsValue = tempArray

            tempValue = result.filter(x => x.title === 'Products-TH-Category')
            tempArray = []
            tempValue.forEach(function (value) {
              tempArray.push(value.value)
            })
            this.productsCategoriesValue = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/showLikeTitle|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showLikeTitle|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getProductsColumns () {
        this.$http.post('products/columns').then(
          response => {
            const result = response.data.ProductsColumns
            const tempArray = []
            const self = this
            result.forEach(function (value) {
              tempArray.push({
                dbitem: value,
                display: self.$t((typeof self.dynamicColumns[value] !== 'undefined') ? self.dynamicColumns[value] : value),
              })
            })
            this.productsItems = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': products/columns|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': products/columns|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getProductsCategoriesColumns () {
        this.$http.post('productCategories/columns').then(
          response => {
            const result = response.data.ProductCategoriesColumns
            const tempArray = []
            const self = this
            result.forEach(function (value) {
              tempArray.push({ dbitem: value, display: self.$t(value) })
            })
            this.productsCategoriesItems = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': productCategories/columns|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': productCategories/columns|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getDynamicColumns () {
        this.$http.post('dynamicColumns/showByTable', {
          table: 'products',
        }).then(
          response => {
            const result = response.data.DynamicColumns
            result.forEach(o => {
              this.dynamicColumns[o.column] = o.title
            })
            this.getProductsColumns()
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|902'
          this.snackbar = true
          console.log(error)
        })
      },
      save () {
        this.btnLoading = true
        const temparray = []
        this.productsValue.forEach(o => {
          temparray.push({ title: 'Products-TH-Operations', value: o, language_id: 1 })
        })
        this.productsCategoriesValue.forEach(o => {
          temparray.push({ title: 'Products-TH-Category', value: o, language_id: 1 })
        })
        this.$http.post('options/destroyAndInsertByTitle', {
          title: ['Products-TH-Operations', 'Products-TH-Category'],
          insertArray: temparray,
        }).then(
          response => {
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_updated')
            this.snackbar = true
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/destroyAndInsertByTitle|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/destroyAndInsertByTitle|902'
          this.snackbar = true
          console.log(error)
        })
        this.btnLoading = false
        // TODO: Save ProductsCategoriesColumns and Other
      },
    },
  }
</script>

<style scoped>

</style>
